import React from 'react';

import { pageurl } from '../../../constants/pageurl';
import { LinkContainer } from '../../utils/reusable/styled';
import { Separator } from '../../utils/styled';
import Icon from './page-illustration';
import { PageContainer, TxtContainer } from './styled';

const Page404 = () => (
	<PageContainer>
		<Icon />
		<TxtContainer>Sorry for the inconvenience</TxtContainer>
		<TxtContainer>
			<span>
				<i className='fas fa-info-circle mr-2' />
			</span>
			Make sure you have the correct generated url
		</TxtContainer>
		<LinkContainer
			to={pageurl.OVERVIEW}
			style={{ textDecoration: 'underline' }}
		>
			Back to Home
		</LinkContainer>
		<Separator customheight={40} />
	</PageContainer>
);

export default Page404;
